import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LenisProvider from "@/components/landing/LenisProvider";
import Home from "@/pages/Home";
import SportsWear from "@/pages/SportsWear";

export default function App() {
  return (
    <BrowserRouter>
      <LenisProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sportswear" element={<SportsWear />} />
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              border: "3px solid #0A0A0A",
              boxShadow: "6px 6px 0 0 #0A0A0A",
              borderRadius: 0,
              fontFamily: "'Space Grotesk', sans-serif",
            },
          }}
        />
      </LenisProvider>
    </BrowserRouter>
  );
}
